'use strict';

var createExtendError = require('./create-extend-error');
var createError = require('./create-error');
var createErrorClass = function createErrorClass(ErrorClass) {
  return function (className, props) {
    var errorClass = createError(className || ErrorClass.name);
    return createExtendError(errorClass, props);
  };
};
module.exports = createErrorClass(Error);
module.exports.type = createErrorClass(TypeError);
module.exports.range = createErrorClass(RangeError);
module.exports.eval = createErrorClass(EvalError);
module.exports.syntax = createErrorClass(SyntaxError);
module.exports.reference = createErrorClass(ReferenceError);
module.exports.uri = createErrorClass(URIError);